module.exports = __webpack_public_path__ + "static/img/icon_city_num.ce8b9f70.png";